var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useState, useEffect } from 'react';
/**
 * 根据截止时间获取倒计时的hook，输出以秒为单位的倒计时
 * @param deadline 倒计时截止时间，时间戳类型
 */
var useCountDown = function (deadline) {
    var _a = __read(useState(function () {
        return deadline - new Date().getTime() > 0 ? deadline - new Date().getTime() : 0;
    }), 2), timeShow = _a[0], setTimeShow = _a[1];
    var _b = __read(useState(false), 2), visibleChange = _b[0], setVisibleChange = _b[1];
    useEffect(function () {
        if (timeShow > 1000) {
            var timmer_1 = setTimeout(function () {
                setTimeShow(deadline - new Date().getTime());
            }, 1000);
            return function () {
                clearTimeout(timmer_1);
            };
        }
    }, [deadline, timeShow, visibleChange]);
    useEffect(function () {
        if (typeof document !== 'undefined') {
            var handleChange_1 = function () {
                setVisibleChange(document.visibilityState === 'visible');
            };
            document.addEventListener('visibilitychange', handleChange_1);
            return function () {
                document.removeEventListener('visibilitychange', handleChange_1);
            };
        }
    }, []);
    return Math.floor(timeShow / 1000);
};
export default useCountDown;
